import { BrowserRouter } from "react-router-dom";
import 'react-tooltip/dist/react-tooltip.css';
import Pages from "./Layout/Pages";
import "./assets/css/style.css";
import { GlobalLoader } from "./Components/GlobalLoader/GlobalLoader";

const App: React.FC = () => {
  return (
    <div className="App">
      <GlobalLoader />
      <BrowserRouter>
        <Pages />
      </BrowserRouter>
    </div>
  );
}
export default App;
